const StorageKeys = {
    favourite_jobs_date: 'favourite_jobs_date'
};

export default StorageKeys;
